import "./App.css";
import { Slide, ToastContainer } from "react-toastify";
import { Route, Routes, useLocation } from "react-router-dom";
import { SecuredRoute } from "./components/Authentication/SecuredRoute";
import { useEffect, useState } from "react";
import { useAppDispatch } from "./hooks/storeHooks";
import { initFetchData } from "./store/thunks/initThunks";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { ApplicationWrapper } from "@idwal/idwal-react-components";
import { cookiePreferences } from "@idwal/idwal-utilities";
import { COOKIE_CONSENT } from "@idwal/idwal-utilities/lib/constants/cookies";
import { useCookies } from "react-cookie";
import Defects from "./pages/Defects";
import { AdjustedGradeEditor } from "./components/Grading/AdjustedGradeEditor";
import AiSummary from "./pages/AiSummary";
import Home from "./pages/Home";
import InspectionList from "./pages/InspectionList";
import AnswersView from "./pages/AnswersView";

const AUTH_URL_PROTOCOL =
    process.env.REACT_APP_ENV === "localhost" ? "http" : "https";

function App() {
    const { user } = useAuthenticator((context) => [context.user]);
    const dispatch = useAppDispatch();

    const [idwalSideBarOpen, setIdwalSideBarOpen] = useState(false);
    const [cookies, setCookie] = useCookies([COOKIE_CONSENT]);

    const cookieUtils = cookiePreferences(setCookie, cookies);

    const location = useLocation();
    const pathParts = location.pathname.split('/');
    const inspectionId = pathParts[1] === 'inspection' ? pathParts[2] : pathParts[1];
    const routePath = '/' + pathParts[1];

    useEffect(() => {
        if (user) {
            dispatch(initFetchData(user));
        }
    }, [user]);

    return (
        <ApplicationWrapper
            showNotifications={false}
            loadingNotifications={false}
            mappedNotifications={[]}
            burgerMenuLogo={"main"}
            logoutLink={`${AUTH_URL_PROTOCOL}://${process.env.REACT_APP_AUTH_URL}/logout?redirect=${window.location.href}`}
            idwalSidebarOtherItems={[
                { label: 'Homepage', url: `/${inspectionId}`, icon: 'pi pi-home' }
            ]}
            idwalSidebarScreeningItems={[
                { label: 'Inspection Defects Editor', url: `/inspection/${inspectionId}/defects`, icon: 'pi pi-exclamation-triangle' },
                { label: 'Adjusted Grade Editor', url: `/inspection/${inspectionId}/adjusted`, icon: 'pi pi-sliders-h' },
                { label: 'AI Summary', url: `/inspection/${inspectionId}/ai-summary`, icon: 'pi pi-file-edit' },
                { label: 'Inspection Answers', url: `/inspection/answers`, icon: 'pi pi-list' }
            ]}
            idwalSidebarIdItems={[]}
            cookieUtils={cookieUtils}
            appSidebarItems={[]}
            activeAppSidebarItem={routePath}
            markAllNotificationsAsRead={() => { }}
            idwalSidebarOpen={idwalSideBarOpen}
            setIdwalSideBarOpen={(open: boolean) => setIdwalSideBarOpen(open)}
        >
            <>
                <ToastContainer
                    position="bottom-right"
                    autoClose={5000}
                    hideProgressBar={true}
                    newestOnTop={true}
                    closeOnClick
                    pauseOnHover
                    theme="colored"
                    transition={Slide}
                />
                <Routes>
                    <Route path="/" element={<SecuredRoute />}>
                        <Route path="/" element={<a href="https://www.idwalmarine.com"><img id="idwal-logo" src="/Idwal-Logo.svg" alt="logo" /></a>} />
                    </Route>
                    <Route path={":inspectionId"} element={<SecuredRoute />}>
                        <Route index element={<Home />} />
                    </Route>
                    <Route path={"/inspection"} element={<SecuredRoute />}>
                        <Route path=":inspectionId/defects" element={<Defects />} />
                        <Route path=":inspectionId/adjusted" element={<AdjustedGradeEditor />} />
                        <Route path=":inspectionId/ai-summary" element={<AiSummary />} />
                        <Route path="answers" element={<InspectionList />} />
                        <Route path="answers/:inspectionId" element={<AnswersView />} />
                    </Route>
                </Routes>
            </>
        </ApplicationWrapper >
    );
}

export default App;
